import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1037491992204255';
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="sssskuh76od1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="swglpsiqd8r8" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-cream text-graphite" data-id="element-2" data-mp="d4e57s05daw6">
        <UrgencyBanner data-id="element-3" data-mp="85l30vqb96bb" />
        <main data-id="element-4" data-mp="851hl51gbzsj">
          <Hero data-id="element-5" data-mp="86mg15qw02vo" />
          <PainSection data-id="element-6" data-mp="8648ve2os48z" />
          <SystemSection data-id="element-7" data-mp="83qgjcze5654" />
          <BonusSection data-id="element-8" data-mp="3gl4q1d0e1shx" />
          <BenefitsSection data-id="element-9" data-mp="3gmfvdh9hf8b5" />
          <Offer data-id="element-10" data-mp="3glnym345f4ja" />
          <Guarantee data-id="element-11" data-mp="3gj1qa19fol00" />
          <Testimonials data-id="element-12" data-mp="3bmtixa1h9w3e" />
          <FAQ data-id="element-13" data-mp="3bncp5thrmw1l" />
          <FinalCTA data-id="element-14" data-mp="3bnuwpm9vowot" />
        </main>
        <Footer data-id="element-15" data-mp="3qb7i9azor2f7" />
        <PurchasePopup data-id="element-16" data-mp="3qbpnuy88mszs" />
      </div>
    </>;
}